import { useQuery } from "@apollo/client/react";
import GET_CLIENT_MESSAGE_EMAIL_TEMPLATES from "../../queries/contentful/getClientMessageEmailTemplates";
import { contentfulClient } from "../../contentfulClient";

interface Response {
  clientMessageTemplatesCollection?: {
    items?: Array<{
      id: string;
      title: string;
      content: string;
    }>;
  };
}

export const useClientMessageEmailTemplates = ({
  skip,
}: {
  skip?: boolean;
}) => {
  const { data, error, loading, refetch } = useQuery<Response>(
    GET_CLIENT_MESSAGE_EMAIL_TEMPLATES,
    {
      client: contentfulClient,
      skip,
    },
  );
  return {
    clientMessageTemplates: data?.clientMessageTemplatesCollection,
    error,
    loading,
    refetch,
  };
};
